/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputChannelMessageReadStatus
 */
export interface InputChannelMessageReadStatus {
    /**
     * 
     * @type {number}
     * @memberof InputChannelMessageReadStatus
     */
    lastReadMessageId: number;
}

/**
 * Check if a given object implements the InputChannelMessageReadStatus interface.
 */
export function instanceOfInputChannelMessageReadStatus(value: object): boolean {
    if (!('lastReadMessageId' in value)) return false;
    return true;
}

export function InputChannelMessageReadStatusFromJSON(json: any): InputChannelMessageReadStatus {
    return InputChannelMessageReadStatusFromJSONTyped(json, false);
}

export function InputChannelMessageReadStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputChannelMessageReadStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'lastReadMessageId': json['lastReadMessageId'],
    };
}

export function InputChannelMessageReadStatusToJSON(value?: InputChannelMessageReadStatus | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'lastReadMessageId': value['lastReadMessageId'],
    };
}

